import { rServices } from '@/plugins/api';

export const USER_DUPLICATE_STATUS_KEY = {
  notProceed: 0,
  merged: 1,
  mergeInitiate: 2,
  notDuplicate: 3,
  inMerge: 4,
  mergeFailed: 5,
};

export const USER_DUPLICATE_MAP = {
  [USER_DUPLICATE_STATUS_KEY.notProceed]: {
    id: USER_DUPLICATE_STATUS_KEY.notProceed,
    name: 'Не обработано',
  },
  [USER_DUPLICATE_STATUS_KEY.merged]: {
    id: USER_DUPLICATE_STATUS_KEY.merged,
    name: 'Процесс слияния успешно произведен',
  },
  [USER_DUPLICATE_STATUS_KEY.mergeInitiate]: {
    id: USER_DUPLICATE_STATUS_KEY.mergeInitiate,
    name: 'Была произведена инициация слияния',
  },
  [USER_DUPLICATE_STATUS_KEY.notDuplicate]: {
    id: USER_DUPLICATE_STATUS_KEY.notDuplicate,
    name: 'Не является дубликатом',
  },
  [USER_DUPLICATE_STATUS_KEY.inMerge]: {
    id: USER_DUPLICATE_STATUS_KEY.inMerge,
    name: 'В процессе слияния',
  },
  [USER_DUPLICATE_STATUS_KEY.mergeFailed]: {
    id: USER_DUPLICATE_STATUS_KEY.mergeFailed,
    name: 'Процесс слияния завершился с ошибкой',
  },
};

export const USER_DUPLICATES = Object.values(USER_DUPLICATE_MAP);

export const USER_DUPLICATE_SOURCE_KEY = {
  email: 1,
  vk: 2,
  apple: 3,
  telegram: 4,
};

export const USER_DUPLICATE_SOURCE_MAP = {
  [USER_DUPLICATE_SOURCE_KEY.email]: {
    id: USER_DUPLICATE_SOURCE_KEY.email,
    name: 'Email',
    backendField: 'is_available_email_merge',
    method: (payload) => rServices.userDuplicates.initiateEmail(payload),
    successMessage: 'Запрос на объединение профилей инициирован',
    icon: 'mdi-email',
  },
  [USER_DUPLICATE_SOURCE_KEY.vk]: {
    id: USER_DUPLICATE_SOURCE_KEY.vk,
    name: 'Вконтакте',
    backendField: 'is_available_vk_merge',
    method: () => rServices.user.getSimpleAuthUriVk({ data: { is_attaching: true } }),
    successMessage: 'Запрос на объединение профилей инициирован',
    icon: '$vk',
  },
  [USER_DUPLICATE_SOURCE_KEY.apple]: {
    id: USER_DUPLICATE_SOURCE_KEY.apple,
    name: 'Apple',
    backendField: 'is_available_apple_merge',
    method: () => rServices.user.getSimpleAuthUriApple({ data: { is_attaching: true } }),
    successMessage: 'Запрос на объединение профилей инициирован',
    icon: 'mdi-apple',
  },
  [USER_DUPLICATE_SOURCE_KEY.telegram]: {
    id: USER_DUPLICATE_SOURCE_KEY.telegram,
    name: 'Телеграм',
    backendField: 'is_available_telegram_merge',
    method: () => rServices.user.getSimpleAuthUriTg({ data: { is_attaching: true } }),
    successMessage: 'Запрос на объединение профилей инициирован',
    icon: '$i-telegram',
  },
};

export const USER_DUPLICATES_LOCAL_STORAGE_KEY = 'userDuplicatesMerge';
